import { IconContainer, Wrapper, Text } from "./styles";

type CurrencyExchangeProps = {
  fromCurrency?: string;
  toCurrency?: string;
  fromAmount?: number;
  toAmount?: number;
  onClick?: () => void;
};

const CurrencyExchange = ({
  fromCurrency = "Currency",
  toCurrency,
  fromAmount,
  toAmount,
  onClick,
}: CurrencyExchangeProps) => {
  return (
    <Wrapper onClick={onClick}>
      <IconContainer>
        <svg
          width="17"
          height="22"
          viewBox="0 0 17 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3461 1V20.5L15.3461 16.5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.34619 20.5L5.34619 1L1.34619 5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconContainer>
      <Text>
        {fromAmount} {fromCurrency} = {toAmount} {toCurrency}
      </Text>
    </Wrapper>
  );
};

export default CurrencyExchange;
